import BaseApi from "../base/BaseApi";

class PopinaApi extends BaseApi {

    private _isDev: boolean

    constructor(isDev: boolean = false, isPopina: boolean = true) {
        super(isDev
            ? (isPopina) ? "https://us-central1-popina-dev.cloudfunctions.net/api/v1" : "https://us-central1-jalia-dev.cloudfunctions.net/api/v1"
            : (isPopina) ? "https://us-central1-popina-prod.cloudfunctions.net/api/v1" : "https://us-central1-jalia-prod.cloudfunctions.net/api/v1",
            false);
        this._isDev = isDev;
    }

    public get isDev(): boolean {
        return this._isDev;
    }

    private get header(): any {
        return {
            'Content-type': 'Application/json',
            'crossDomain': "true",
            'Authorization': 'Bearer lzPoPoiZ19OplVETRyzWyK9T5fNDiPl9'
        };
    }

    firAuthToken(establishmentId: string) {
        const target = '/auth/' + establishmentId.toString();
        return this.getRequest(target, this.header);
    }

}

export default PopinaApi;